import React from "react";
import { Modal } from "reactstrap";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import uploadImg from "../../assets/img/icons/upload.png";
import Spinner from "reactstrap/lib/Spinner";
import { base_url, client_Id, client_Secret } from "assets/utils/const";
class PersonalDoc extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fileFront: null,
      fileBack: null,
      filePan: null,
      individualddlAddress: null,
      proprietorddlAddress: null,
      partnerd1ddlAddress: null,
      partnerd2ddlAddress: null,
      publicd1ddlAddress: null,
      publicd2ddlAddress: null,
      trustd1ddlAddress: null,
      trustd2ddlAddress: null,
      isLoaded: false,
      agree: false,
      submit: false,
      fileSizeError1: false,
      fileSizeError2: false,
      fileSizeError3: false,
      imageUploadedError1: false,
      imageUploadedError2: false,
      imageUploadedError3: false,
      fileSizeErrorMsg1: "",
      fileSizeErrorMsg2: "",
      fileSizeErrorMsg3: "",
      authToken: localStorage.getItem("Authtoken"),
      btype: "",
      meId: "",
      category: "",
    };
    this.individualpreviewFront = this.individualpreviewFront.bind(this);
    this.individualpreviewBack = this.individualpreviewBack.bind(this);
    this.individualpreviewPan = this.individualpreviewPan.bind(this);

    this.proprietorpreviewFront = this.proprietorpreviewFront.bind(this);
    this.proprietorpreviewBack = this.proprietorpreviewBack.bind(this);
    this.proprietorpreviewPan = this.proprietorpreviewPan.bind(this);

    this.partnerd1previewFront = this.partnerd1previewFront.bind(this);
    this.partnerd1previewBack = this.partnerd1previewBack.bind(this);
    this.partnerd1previewPan = this.partnerd1previewPan.bind(this);
    this.partnerd2previewFront = this.partnerd2previewFront.bind(this);
    this.partnerd2previewBack = this.partnerd2previewBack.bind(this);
    this.partnerd2previewPan = this.partnerd2previewPan.bind(this);

    this.publicd1previewFront = this.publicd1previewFront.bind(this);
    this.publicd1previewBack = this.publicd1previewBack.bind(this);
    this.publicd1previewPan = this.publicd1previewPan.bind(this);
    this.publicd2previewFront = this.publicd2previewFront.bind(this);
    this.publicd2previewBack = this.publicd2previewBack.bind(this);
    this.publicd2previewPan = this.publicd2previewPan.bind(this);

    this.trustd1previewFront = this.trustd1previewFront.bind(this);
    this.trustd1previewBack = this.trustd1previewBack.bind(this);
    this.trustd1previewPan = this.trustd1previewPan.bind(this);
    this.trustd2previewFront = this.trustd2previewFront.bind(this);
    this.trustd2previewBack = this.trustd2previewBack.bind(this);
    this.trustd2previewPan = this.trustd2previewPan.bind(this);
  }

  componentDidMount() {
    if (!localStorage.getItem("Authtoken")) {
      window.location.href = "/login";
    }
    fetch(`${base_url}api/dmoAuthApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: this.state.authToken,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.statusCode == "200") {
          const payloadDetails = JSON.parse(result.payLoad);

          this.setState({
            btype: payloadDetails.BusinessType,
            meId: payloadDetails.meId,
            category: payloadDetails.category,
          });
          console.log("details payload state", this.state.btype);
          console.log("details payload", payloadDetails.BusinessType);
          this.initialData();
        } else {
          if (
            result.payLoad === `Session Expired Please Login` ||
            result.payLoad === `Incorrect Token`
          ) {
            this.toggleModal("loginModal");
          }
        }
      });
  }
  initialData = () => {
    const { btype } = this.state;
    if (btype === "Individual") {
      let address = localStorage.getItem("address");
      if (localStorage.getItem(address)) {
        this.individualAddress(address);
      }
      if (localStorage.getItem("Pan Card")) {
        this.individualPan();
      }
    } else if (btype === "Proprietorship") {
      let address = localStorage.getItem("address");
      if (localStorage.getItem(address)) {
        this.proprietorAddress();
      }
      if (localStorage.getItem("Pan Card")) {
        this.proprietorPan();
      }
    } else if (btype === "Partnership/LLP") {
      let address1 = localStorage.getItem("address1");
      let address2 = localStorage.getItem("address2");
      if (localStorage.getItem(address1)) {
        this.partnerAddress1(address1.split(" "));
      }
      if (localStorage.getItem(address2)) {
        this.partnerAddress2(address2.split(" "));
      }
      if (localStorage.getItem("Pan Card 1")) {
        this.partnerPanCard1();
      }
      if (localStorage.getItem("Pan Card 2")) {
        this.partnerPanCard2();
      }
    } else if (btype === "PrivateLtd./PublicLtd.") {
      let address1 = localStorage.getItem("address1");
      let address2 = localStorage.getItem("address2");
      if (localStorage.getItem(address1)) {
        this.publicAddress1(address1.split(" "));
      }
      if (localStorage.getItem(address2)) {
        this.publicAddress2(address2.split(" "));
      }
      if (localStorage.getItem("Pan Card 1")) {
        this.publicPanCard1();
      }
      if (localStorage.getItem("Pan Card 2")) {
        this.publicPanCard2();
      }
    } else if (btype === "Trust/Society") {
      let address1 = localStorage.getItem("address1");
      let address2 = localStorage.getItem("address2");
      if (localStorage.getItem(address1)) {
        this.societyAddress1(address1.split(" "));
      }
      if (localStorage.getItem(address2)) {
        this.societyAddress2(address2.split(" "));
      }
      if (localStorage.getItem("Pan Card 1")) {
        this.societyPanCard1();
      }
      if (localStorage.getItem("Pan Card 2")) {
        this.societyPanCard2();
      }
    }
  };
  individualAddress = (address) => {
    var udocumenttypename = document.getElementById("individualddlAddress");
    udocumenttypename.disabled = true;
    if (address) {
      udocumenttypename.value = address;
    }
    var txtindividualAadhaarCount = document.getElementById(
      "txtindividualAadhaarCount"
    );
    var btnindividualAadhaar = document.getElementById("btnindividualAadhaar");
    txtindividualAadhaarCount.value = 1;
    btnindividualAadhaar.disabled = true;
    btnindividualAadhaar.style.background = "#2faa4a";
    btnindividualAadhaar.innerText = "UPLOADED";
  };
  individualPan = () => {
    var txtindividualPanCount = document.getElementById(
      "txtindividualPanCount"
    );
    var btnindividualPan = document.getElementById("btnindividualPan");
    txtindividualPanCount.value = 1;
    btnindividualPan.disabled = true;
    btnindividualPan.style.background = "#2faa4a";
    btnindividualPan.innerText = "UPLOADED";
  };
  proprietorAddress = (address) => {
    let udocumenttypename = document.getElementById("proprietorddlAddress");
    udocumenttypename.disabled = true;
    if (address) {
      udocumenttypename.value = address;
    }
    let txtproprietorAadhaarCount = document.getElementById(
      "txtproprietorAadhaarCount"
    );

    let btnproprietorAadhaar = document.getElementById("btnproprietorAadhaar");
    txtproprietorAadhaarCount.value = 1;
    btnproprietorAadhaar.disabled = true;
    btnproprietorAadhaar.innerText = "UPLOADED";
    btnproprietorAadhaar.style.background = "#2faa4a";
  };
  proprietorPan = () => {
    var txtproprietorPanCount = document.getElementById(
      "txtproprietorPanCount"
    );
    var btnproprietorPan = document.getElementById("btnproprietorPan");
    txtproprietorPanCount.value = 1;
    btnproprietorPan.disabled = true;
    btnproprietorPan.style.background = "#2faa4a";
    btnproprietorPan.innerText = "UPLOADED";
  };
  partnerAddress1(address) {
    var txtpartnerd1AadhaarCount = document.getElementById(
      "txtpartnerd1AadhaarCount"
    );
    var btnpartnerd1Aadhaar = document.getElementById("btnpartnerd1Aadhaar");
    let fieldName = document.getElementById("partnerd1ddlAddress");
    if (address) {
      fieldName.value = address.includes("Passport")
        ? "Passport"
        : address[0] + " " + address[1];
    }

    fieldName.disabled = true;

    txtpartnerd1AadhaarCount.value = 1;
    btnpartnerd1Aadhaar.disabled = true;
    btnpartnerd1Aadhaar.style.background = "#2faa4a";
    btnpartnerd1Aadhaar.innerText = "UPLOADED";
  }
  partnerAddress2(address) {
    var txtpartnerd2AadhaarCount = document.getElementById(
      "txtpartnerd2AadhaarCount"
    );
    var btnpartnerd2Aadhaar = document.getElementById("btnpartnerd2Aadhaar");
    let fieldName = document.getElementById("partnerd2ddlAddress");
    if (address) {
      fieldName.value = address.includes("Passport")
        ? "Passport"
        : address[0] + " " + address[1];
    }
    fieldName.disabled = true;
    txtpartnerd2AadhaarCount.value = 1;
    btnpartnerd2Aadhaar.disabled = true;
    btnpartnerd2Aadhaar.style.background = "#2faa4a";
    btnpartnerd2Aadhaar.innerText = "UPLOADED";
  }
  partnerPanCard1() {
    var txtpartnerd1PanCount = document.getElementById("txtpartnerd1PanCount");
    var btnpartnerd1Pan = document.getElementById("btnpartnerd1Pan");
    txtpartnerd1PanCount.value = 1;
    btnpartnerd1Pan.disabled = true;
    btnpartnerd1Pan.style.background = "#2faa4a";
    btnpartnerd1Pan.innerText = "UPLOADED";
  }
  partnerPanCard2() {
    var txtpartnerd2PanCount = document.getElementById("txtpartnerd2PanCount");
    var btnpartnerd2Pan = document.getElementById("btnpartnerd2Pan");
    txtpartnerd2PanCount.value = 1;
    btnpartnerd2Pan.disabled = true;
    btnpartnerd2Pan.style.background = "#2faa4a";
    btnpartnerd2Pan.innerText = "UPLOADED";
  }
  publicAddress1(address) {
    var txtpublicd1AadhaarCount = document.getElementById(
      "txtpublicd1AadhaarCount"
    );
    var btnpublicd1Aadhaar = document.getElementById("btnpublicd1Aadhaar");
    let fieldName = document.getElementById("publicd1ddlAddress");
    if (address) {
      fieldName.value = address.includes("Passport")
        ? "Passport"
        : address[0] + " " + address[1];
    }
    fieldName.disabled = true;
    txtpublicd1AadhaarCount.value = 1;

    btnpublicd1Aadhaar.disabled = true;
    btnpublicd1Aadhaar.style.background = "#2faa4a";
    btnpublicd1Aadhaar.innerText = "UPLOADED";
  }
  publicAddress2(address) {
    var txtpublicd2AadhaarCount = document.getElementById(
      "txtpublicd2AadhaarCount"
    );
    var btnpublicd2Aadhaar = document.getElementById("btnpublicd2Aadhaar");
    let fieldName = document.getElementById("publicd2ddlAddress");
    if (address) {
      fieldName.value = address.includes("Passport")
        ? "Passport"
        : address[0] + " " + address[1];
    }
    fieldName.disabled = true;
    txtpublicd2AadhaarCount.value = 1;
    btnpublicd2Aadhaar.disabled = true;
    btnpublicd2Aadhaar.style.background = "#2faa4a";
    btnpublicd2Aadhaar.innerText = "UPLOADED";
  }
  publicPanCard1() {
    var txtpublicd1PanCount = document.getElementById("txtpublicd1PanCount");
    var btnpublicd1Pan = document.getElementById("btnpublicd1Pan");
    txtpublicd1PanCount.value = 1;
    btnpublicd1Pan.disabled = true;
    btnpublicd1Pan.style.background = "#2faa4a";
    btnpublicd1Pan.innerText = "UPLOADED";
  }
  publicPanCard2() {
    var txtpublicd2PanCount = document.getElementById("txtpublicd2PanCount");
    var btnpublicd2Pan = document.getElementById("btnpublicd2Pan");
    txtpublicd2PanCount.value = 1;
    btnpublicd2Pan.disabled = true;
    btnpublicd2Pan.style.background = "#2faa4a";
    btnpublicd2Pan.innerText = "UPLOADED";
  }
  societyAddress1(address) {
    var txttrustd1AadhaarCount = document.getElementById(
      "txttrustd1AadhaarCount"
    );
    var btntrustd1Aadhaar = document.getElementById("btntrustd1Aadhaar");
    let fieldName = document.getElementById("trustd1ddlAddress");
    if (address) {
      fieldName.value = address.includes("Passport")
        ? "Passport"
        : address[0] + " " + address[1];
    }
    fieldName.disabled = true;
    txttrustd1AadhaarCount.value = 1;
    btntrustd1Aadhaar.disabled = true;
    btntrustd1Aadhaar.style.background = "#2faa4a";
    btntrustd1Aadhaar.innerText = "UPLOADED";
  }
  societyAddress2(address) {
    var txttrustd2AadhaarCount = document.getElementById(
      "txttrustd2AadhaarCount"
    );
    var btntrustd2Aadhaar = document.getElementById("btntrustd2Aadhaar");
    let fieldName = document.getElementById("trustd2ddlAddress");
    if (address) {
      fieldName.value = address.includes("Passport")
        ? "Passport"
        : address[0] + " " + address[1];
    }
    fieldName.disabled = true;
    txttrustd2AadhaarCount.value = 1;
    btntrustd2Aadhaar.disabled = true;
    btntrustd2Aadhaar.style.background = "#2faa4a";
    btntrustd2Aadhaar.innerText = "UPLOADED";
  }
  societyPanCard1() {
    var txttrustd1PanCount = document.getElementById("txttrustd1PanCount");
    var btntrustd1Pan = document.getElementById("btntrustd1Pan");
    txttrustd1PanCount.value = 1;
    btntrustd1Pan.disabled = true;
    btntrustd1Pan.style.background = "#2faa4a";
    btntrustd1Pan.innerText = "UPLOADED";
  }
  societyPanCard2() {
    var txttrustd2PanCount = document.getElementById("txttrustd2PanCount");
    var btntrustd2Pan = document.getElementById("btntrustd2Pan");
    txttrustd2PanCount.value = 1;
    btntrustd2Pan.disabled = true;
    btntrustd2Pan.style.background = "#2faa4a";
    btntrustd2Pan.innerText = "UPLOADED";
  }
  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
      fileSizeError1: false,
      fileSizeError2: false,
      fileSizeError3: false,
      fileSizeErrorMsg1: "",
      fileSizeErrorMsg2: "",
      fileSizeErrorMsg3: "",
      imageUploadedError1: false,
      imageUploadedError2: false,
      imageUploadedError3: false,
    });
  };
  handleCloseModal = (e, key) => {
    e.preventDefault();
    this.toggleModal(key);
    this.setState({
      submit: false,
      agree: false,
    });
  };
  individualpreviewFront(event) {
    this.setState({ individualfileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            individualfileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblindividualfileItemFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  individualpreviewBack(event) {
    this.setState({ individualfileBack: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            individualfileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblindividualfileItemBack").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  individualpreviewPan(event) {
    this.setState({ individualfilePan: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            individualfilePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblindividualfileItemPan").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  proprietorpreviewFront(event) {
    this.setState({ proprietorfileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorfileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblproprietorfileItemFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorpreviewBack(event) {
    this.setState({ proprietorfileBack: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorfileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblproprietorfileItemBack").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorpreviewPan(event) {
    this.setState({ proprietorfilePan: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          proprietorfilePan: URL.createObjectURL(event.target.files[0]),
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorfilePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblproprietorfileItemPan").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  partnerd1previewFront(event) {
    this.setState({ partnerd1fileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerd1fileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpartnerd1fileItemFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerd1previewBack(event) {
    this.setState({ partnerd1fileBack: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerd1fileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpartnerd1fileItemBack").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerd1previewPan(event) {
    this.setState({ partnerd1filePan: "" });
    let file = event.target.files[0];

    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerd1filePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpartnerd1fileItemPan").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerd2previewFront(event) {
    this.setState({ partnerd2fileFront: "" });
    let file = event.target.files[0];

    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerd2fileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpartnerd2fileItemFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerd2previewBack(event) {
    this.setState({ partnerd2fileBack: "" });
    let file = event.target.files[0];

    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerd2fileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpartnerd2fileItemBack").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerd2previewPan(event) {
    this.setState({ partnerd2filePan: "" });
    let file = event.target.files[0];

    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerd2filePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpartnerd2fileItemPan").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  publicd1previewFront(event) {
    this.setState({ publicd1fileFront: "" });
    let file = event.target.files[0];

    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicd1fileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpublicd1fileItemFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicd1previewBack(event) {
    let file = event.target.files[0];
    this.setState({
      publicd1fileBack: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicd1fileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpublicd1fileItemBack").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicd1previewPan(event) {
    let file = event.target.files[0];
    this.setState({
      publicd1filePan: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicd1filePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpublicd1fileItemPan").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicd2previewFront(event) {
    let file = event.target.files[0];
    this.setState({
      publicd2fileFront: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicd2fileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpublicd2fileItemFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicd2previewBack(event) {
    let file = event.target.files[0];
    this.setState({
      publicd2fileBack: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicd2fileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpublicd2fileItemBack").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicd2previewPan(event) {
    let file = event.target.files[0];
    this.setState({
      publicd2filePan: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicd2filePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lblpublicd2fileItemPan").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  trustd1previewFront(event) {
    let file = event.target.files[0];
    this.setState({
      trustd1fileFront: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            trustd1fileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lbltrustd1fileItemFront").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  trustd1previewBack(event) {
    let file = event.target.files[0];
    this.setState({
      trustd1fileBack: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            trustd1fileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lbltrustd1fileItemBack").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  trustd1previewPan(event) {
    let file = event.target.files[0];
    this.setState({
      trustd1filePan: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            trustd1filePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lbltrustd1fileItemPan").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  trustd2previewFront(event) {
    let file = event.target.files[0];
    this.setState({
      trustd2fileFront: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg1: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg1: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            trustd2fileFront: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lbltrustd2fileItemFront").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  trustd2previewBack(event) {
    let file = event.target.files[0];
    this.setState({
      trustd2fileBack: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError2: true,
          fileSizeErrorMsg2: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg2: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            trustd2fileBack: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lbltrustd2fileItemBack").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  trustd2previewPan(event) {
    let file = event.target.files[0];
    this.setState({
      trustd2filePan: "",
    });
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError3: true,
          fileSizeErrorMsg3: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError3: false,
          fileSizeErrorMsg3: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            trustd2filePan: "data:image/png;base64 ," + base64,
          });
          document.getElementById("lbltrustd2fileItemPan").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  showAddressModal() {}

  handleChange = (event) => {
    this.setState({ individualddlAddress: event.target.value });
  };

  handleproprietorChange = (event) => {
    this.setState({ proprietorddlAddress: event.target.value });
  };

  handlepartnerd1Change = (event) => {
    this.setState({ partnerd1ddlAddress: event.target.value });
  };
  handlepartnerd2Change = (event) => {
    this.setState({ partnerd2ddlAddress: event.target.value });
  };

  handlepublicd1Change = (event) => {
    this.setState({ publicd1ddlAddress: event.target.value });
  };
  handlepublicd2Change = (event) => {
    this.setState({ publicd2ddlAddress: event.target.value });
  };

  handletrustd1Change = (event) => {
    this.setState({ trustd1ddlAddress: event.target.value });
  };
  handletrustd2Change = (event) => {
    this.setState({ trustd2ddlAddress: event.target.value });
  };

  individualsubmitAddress = (event) => {
    event.preventDefault();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblindividualfileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lblindividualfileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Individual"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("individualddlAddress");
    var furl = this.state.individualfileFront;
    var burl = this.state.individualfileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        me_id: this.state.meId,
        business_type: "Individual",
        document_type: udocumenttype,
        should_verify: "false",
        document_type_name: udocumenttypename.value,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          //alert(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            const details = JSON.parse(result.payLoad);
            this.setState({ submit: true });
            document.getElementById("nameIndividual").value = details.name;
            document.getElementById("idIndividual").value = details.id_no;
            document.getElementById("addressIndividual").value = details.address
              ? details.address
              : "";
            this.individualAddress();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  individualsubmitPan = (event) => {
    event.preventDefault();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblindividualfileItemPan");
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Individual"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.individualfilePan;
    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            const details = JSON.parse(result.payLoad);
            this.setState({ submit: true });
            document.getElementById("panCardNameInd").value = details.name;
            document.getElementById("panCardFNameInd").value =
              details.fathers_name;
            document.getElementById("panCardNuInd").value = details.id_no;
            document.getElementById("panCardDOBInd").value = details.dob;

            this.individualPan();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  proprietorsubmitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblproprietorfileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lblproprietorfileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Proprietorship"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("proprietorddlAddress");
    var furl = this.state.proprietorfileFront;
    var burl = this.state.proprietorfileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("namePropriet").value = details.name;
            document.getElementById("idPropriet").value = details.id_no;
            document.getElementById("addressPropriet").value = details.address
              ? details.address
              : "";
            this.proprietorAddress();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  proprietorsubmitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblproprietorfileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Proprietorship"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.proprietorfilePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("panCardNamePro").value = details.name;
            document.getElementById("panCardFNamePro").value =
              details.fathers_name;
            document.getElementById("panCardNuPro").value = details.id_no;
            document.getElementById("panCardDOBPro").value = details.dob;
            this.proprietorPan();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  partnerd1submitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpartnerd1fileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lblpartnerd1fileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("partnerd1ddlAddress");
    var furl = this.state.partnerd1fileFront;
    var burl = this.state.partnerd1fileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value + " 1",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("namePartnerd1").value = details.name;
            document.getElementById("idPartnerd1").value = details.id_no;
            document.getElementById("addressPartnerd1").value = details.address
              ? details.address
              : "";
            this.partnerAddress1();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerd1submitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblpartnerd1fileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.partnerd1filePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename + " 1",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });

            const details = JSON.parse(result.payLoad);
            document.getElementById("panNamePartnerd1").value = details.name;
            document.getElementById("panFNamePartnerd1").value =
              details.fathers_name;
            document.getElementById("panNuPartnerd1").value = details.id_no;
            document.getElementById("panDOBPartnerd1").value = details.dob;
            this.partnerPanCard1();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerd2submitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpartnerd2fileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lblpartnerd2fileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("partnerd2ddlAddress");
    var furl = this.state.partnerd2fileFront;
    var burl = this.state.partnerd2fileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }

    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value + " 2",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("namePartnerd2").value = details.name;
            document.getElementById("idPartnerd2").value = details.id_no;
            document.getElementById("addressPartnerd2").value = details.address
              ? details.address
              : "";
            this.partnerAddress2();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerd2submitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblpartnerd2fileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.partnerd2filePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename + " 2",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("panNamePartnerd2").value = details.name;
            document.getElementById("panFNamePartnerd2").value =
              details.fathers_name;
            document.getElementById("panNuPartnerd2").value = details.id_no;
            document.getElementById("panDOBPartnerd2").value = details.dob;
            this.partnerPanCard2();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  publicd1submitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpublicd1fileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lblpublicd1fileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("publicd1ddlAddress");
    var furl = this.state.publicd1fileFront;
    var burl = this.state.publicd1fileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }

    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value + " 1",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });

            const details = JSON.parse(result.payLoad);
            document.getElementById("namePublicd1").value = details.name;
            document.getElementById("idPublicd1").value = details.id_no;
            document.getElementById("addressPublicd1").value = details.address
              ? details.address
              : "";
            this.publicAddress1();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicd1submitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblpublicd1fileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.publicd1filePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename + " 1",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("panNamePublicd1").value = details.name;
            document.getElementById("panFNamePublicd1").value =
              details.fathers_name;
            document.getElementById("panNuPublicd1").value = details.id_no;
            document.getElementById("panDOBPublicd1").value = details.dob;
            this.publicPanCard1();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicd2submitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpublicd2fileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lblpublicd2fileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("publicd2ddlAddress");
    var furl = this.state.publicd2fileFront;
    var burl = this.state.publicd2fileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }

    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value + " 2",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("namePublicd2").value = details.name;
            document.getElementById("idPublicd2").value = details.id_no;
            document.getElementById("addressPublicd2").value = details.address
              ? details.address
              : "";
            this.publicAddress2();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicd2submitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblpublicd2fileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.publicd2filePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename + " 2",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("panNamePublicd2").value = details.name;
            document.getElementById("panFNamePublicd2").value =
              details.fathers_name;
            document.getElementById("panNuPublicd2").value = details.id_no;
            document.getElementById("panDOBPublicd2").value = details.dob;
            this.publicPanCard2();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  trustd1submitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lbltrustd1fileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lbltrustd1fileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("trustd1ddlAddress");
    var furl = this.state.trustd1fileFront;
    var burl = this.state.trustd1fileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }

    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },

      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value + " 1",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("nameTrustd1").value = details.name;
            document.getElementById("idTrustd1").value = details.id_no;
            document.getElementById("addressTrustd1").value = details.address
              ? details.address
              : "";
            this.societyAddress1();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  trustd1submitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lbltrustd1fileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.trustd1filePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename + " 1",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("panNameTrustd1").value = details.name;
            document.getElementById("panFNameTrustd1").value =
              details.fathers_name;
            document.getElementById("panNuTrustd1").value = details.id_no;
            document.getElementById("panDOBTrustd1").value = details.dob;
            this.societyPanCard1();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  trustd2submitAddress = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lbltrustd2fileItemFront"); //this.state.fileFront;
    var ubackpart = document.getElementById("lbltrustd2fileItemBack"); //this.state.fileBack;
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = document.getElementById("trustd2ddlAddress");
    var furl = this.state.trustd2fileFront;
    var burl = this.state.trustd2fileBack;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }

    if (!burl) {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: burl,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename.value + " 2",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("nameTrustd2").value = details.name;
            document.getElementById("idTrustd2").value = details.id_no;
            document.getElementById("addressTrustd2").value = details.address
              ? details.address
              : "";
            this.societyAddress2();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  trustd2submitPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lbltrustd2fileItemPan"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "personal document";
    var udocumenttypename = "Pan Card";
    var furl = this.state.trustd2filePan;

    if (!furl) {
      this.setState({ imageUploadedError3: true });
      return false;
    } else {
      this.setState({ imageUploadedError3: false });
    }

    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        // auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename + " 2",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            const details = JSON.parse(result.payLoad);
            document.getElementById("panNameTrustd2").value = details.name;
            document.getElementById("panFNameTrustd2").value =
              details.fathers_name;
            document.getElementById("panNuTrustd2").value = details.id_no;
            document.getElementById("panDOBTrustd2").value = details.dob;
            this.societyPanCard2();
          }
          //localStorage.clear();
          //window.location.href = "/signuplogin";
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  checkNthank = () => {
    var txtindividualAadhaarCount = document.getElementById(
      "txtindividualAadhaarCount"
    );
    var txtindividualPanCount = document.getElementById(
      "txtindividualPanCount"
    );
    var txtproprietorAadhaarCount = document.getElementById(
      "txtproprietorAadhaarCount"
    );
    var txtproprietorPanCount = document.getElementById(
      "txtproprietorPanCount"
    );
    var txtpartnerd1AadhaarCount = document.getElementById(
      "txtpartnerd1AadhaarCount"
    );
    var txtpartnerd1PanCount = document.getElementById("txtpartnerd1PanCount");
    var txtpartnerd2AadhaarCount = document.getElementById(
      "txtpartnerd2AadhaarCount"
    );
    var txtpartnerd2PanCount = document.getElementById("txtpartnerd2PanCount");
    var txtpublicd1AadhaarCount = document.getElementById(
      "txtpublicd1AadhaarCount"
    );
    var txtpublicd1PanCount = document.getElementById("txtpublicd1PanCount");
    var txtpublicd2AadhaarCount = document.getElementById(
      "txtpublicd2AadhaarCount"
    );
    var txtpublicd2PanCount = document.getElementById("txtpublicd2PanCount");
    var txttrustd1AadhaarCount = document.getElementById(
      "txttrustd1AadhaarCount"
    );
    var txttrustd1PanCount = document.getElementById("txttrustd1PanCount");
    var txttrustd2AadhaarCount = document.getElementById(
      "txttrustd2AadhaarCount"
    );
    var txttrustd2PanCount = document.getElementById("txttrustd2PanCount");

    if (this.state.btype == "Individual") {
      if (
        parseInt(txtindividualAadhaarCount.value) === 1 &&
        parseInt(txtindividualPanCount.value) === 1
       
      ) {
        window.location.href = "/success";
    }
    } else if (this.state.btype == "Proprietorship") {
      if (
        parseInt(txtproprietorAadhaarCount.value) === 1 &&
        parseInt(txtproprietorPanCount.value) === 1
      ) {
        window.location.href = "/businessprop";
      }
    } else if (this.state.btype == "Partnership/LLP") {
      if (
        parseInt(txtpartnerd1AadhaarCount.value) === 1 &&
        parseInt(txtpartnerd1PanCount.value) === 1 &&
        parseInt(txtpartnerd2AadhaarCount.value) === 1 &&
        parseInt(txtpartnerd2PanCount.value) === 1
      ) {
        window.location.href = "/businesspart";
      }
    } else if (this.state.btype == "PrivateLtd./PublicLtd.") {
      if (
        parseInt(txtpublicd1AadhaarCount.value) === 1 &&
        parseInt(txtpublicd1PanCount.value) === 1 &&
        parseInt(txtpublicd2AadhaarCount.value) === 1 &&
        parseInt(txtpublicd2PanCount.value) === 1
      ) {
        window.location.href = "/businesspub";
      }
    } else if (this.state.btype == "Trust/Society") {
      if (
        parseInt(txttrustd1AadhaarCount.value) === 1 &&
        parseInt(txttrustd1PanCount.value) === 1 &&
        parseInt(txttrustd2AadhaarCount.value) === 1 &&
        parseInt(txttrustd2PanCount.value) === 1
      ) {
        window.location.href = "/businesssoc";
      }
    }
  };

  render() {
    return (
      <>
        <section className="dv-Registration-content doc-main-div">
          <div className="first-bg htg"></div>
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Quick &amp; Easy Activation Process
                </h1>
                <div className="row">
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 1</div>
                      <div className="text">
                        Check email for Username &amp; OTP.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 2</div>
                      <div className="text">
                        Enter Username &amp; OTP. <br />
                        Set a desirable password.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step">
                      <div className="step">Step 3</div>
                      <div className="text">
                        Fill in all the details &amp; upload documents to start
                        activation process.
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="tick mt-3 mr-5">
                  <li className="completed">
                    Business Overview <span className="hr-white"></span>{" "}
                  </li>
                  {/* <li className="completed">Business Contact Details <span className="hr-white"></span></li> */}
                  <li className="completed">
                    Bank Account Details <span className="hr-white"></span>
                  </li>
                  <li>Agreement &amp; KYC Documents</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="dv-login-form dv-form">
                  <h1 className="section-heading border-heading no-border-heading">
                    {this.props.name}
                  </h1>
                  <div className="dv-indicator">
                    <ul className="indicator">
                      <li className="box completed"></li>
                      <li className="line"></li>
                      <li className="box"></li>
                      {/* <li className="line pid"></li>
                                            <li className="box pid"></li> */}
                    </ul>
                  </div>
                  <h4 className="text-center doc-txt">Personal Documents</h4>

                  {/* <div className="dv-doc dv-ind dv-prop">
                                        <div className="dv-particular">
                                            <label className="lbl">Identity Proof</label>
                                            <span className="note">Select your prefered Idenity  Proof</span>
                                        </div>
                                        <div className="dv-field">
                                            <select className="custom-select">
                                                <option>Select</option>
                                            </select>
                                            <button className="btn btn-green">VERIFIED</button>
                                        </div>
                                    </div> */}

                  <div className="dv-doc dv-ind">
                    <div className="dv-particular">
                      <label className="lbl">
                        Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="individualddlAddress"
                        onChange={this.handleChange}
                        value={this.state.individualddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txtindividualAadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnindividualAadhaar"
                        onClick={() =>
                          this.toggleModal("individualuploadModalAadhaar")
                        }
                        disabled={
                          !this.state.individualddlAddress ||
                          this.state.individualddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-ind">
                    <div className="dv-particular">
                      <label className="lbl">
                        PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtindividualPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnindividualPan"
                        onClick={() =>
                          this.toggleModal("individualuploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>

                  <div className="dv-doc dv-prop">
                    <div className="dv-particular">
                      <label className="lbl">
                        Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="proprietorddlAddress"
                        onChange={this.handleproprietorChange}
                        value={this.state.proprietorddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txtproprietorAadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnproprietorAadhaar"
                        onClick={() =>
                          this.toggleModal("proprietoruploadModalAadhaar")
                        }
                        disabled={
                          !this.state.proprietorddlAddress ||
                          this.state.proprietorddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-prop">
                    <div className="dv-particular">
                      <label className="lbl">
                        PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtproprietorPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnproprietorPan"
                        onClick={() =>
                          this.toggleModal("proprietoruploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>

                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 1 : Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="partnerd1ddlAddress"
                        onChange={this.handlepartnerd1Change}
                        value={this.state.partnerd1ddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerd1AadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerd1Aadhaar"
                        onClick={() =>
                          this.toggleModal("partnerd1uploadModalAadhaar")
                        }
                        disabled={
                          !this.state.partnerd1ddlAddress ||
                          this.state.partnerd1ddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 2 : Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="partnerd2ddlAddress"
                        onChange={this.handlepartnerd2Change}
                        value={this.state.partnerd2ddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerd2AadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerd2Aadhaar"
                        onClick={() =>
                          this.toggleModal("partnerd2uploadModalAadhaar")
                        }
                        disabled={
                          !this.state.partnerd2ddlAddress ||
                          this.state.partnerd2ddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 1 : PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerd1PanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerd1Pan"
                        onClick={() =>
                          this.toggleModal("partnerd1uploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 2 : PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerd2PanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerd2Pan"
                        onClick={() =>
                          this.toggleModal("partnerd2uploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  {/* <div className="dv-doc dv-part">
                                        <div className="dv-particular">
                                            <label className="lbl">Address Proof</label>
                                            <span className="note">Select your prefered Address Proof</span>
                                        </div>
                                        <div className="dv-field">
                                            <select className="custom-select">
                                                <option>Select</option>
                                            </select>
                                            <button className="btn btn-lightblue" onClick={() => this.toggleModal("uploadModal")}>UPLOAD</button>
                                        </div>
                                    </div> */}

                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 1 : Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="publicd1ddlAddress"
                        onChange={this.handlepublicd1Change}
                        value={this.state.publicd1ddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicd1AadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicd1Aadhaar"
                        onClick={() =>
                          this.toggleModal("publicd1uploadModalAadhaar")
                        }
                        disabled={
                          !this.state.publicd1ddlAddress ||
                          this.state.publicd1ddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 2 : Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="publicd2ddlAddress"
                        onChange={this.handlepublicd2Change}
                        value={this.state.publicd2ddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicd2AadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicd2Aadhaar"
                        onClick={() =>
                          this.toggleModal("publicd2uploadModalAadhaar")
                        }
                        disabled={
                          !this.state.publicd2ddlAddress ||
                          this.state.publicd2ddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 1 : PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicd1PanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicd1Pan"
                        onClick={() =>
                          this.toggleModal("publicd1uploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 2 : PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicd2PanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicd2Pan"
                        onClick={() =>
                          this.toggleModal("publicd2uploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>

                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 1 : Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="trustd1ddlAddress"
                        onChange={this.handletrustd1Change}
                        value={this.state.trustd1ddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txttrustd1AadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btntrustd1Aadhaar"
                        onClick={() =>
                          this.toggleModal("trustd1uploadModalAadhaar")
                        }
                        disabled={
                          !this.state.trustd1ddlAddress ||
                          this.state.trustd1ddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 2 : Address Proof<span className="red">*</span>
                      </label>
                      <span className="note">
                        Select your prefered Address Proof
                      </span>
                    </div>
                    <div className="dv-field sel-doc">
                      <select
                        className="custom-select"
                        id="trustd2ddlAddress"
                        onChange={this.handletrustd2Change}
                        value={this.state.trustd2ddlAddress}
                      >
                        <option value="-1">Select</option>
                        <option value="Driving License">Driving License</option>
                        <option value="Voter ID">Voter ID</option>
                        <option value="Aadhaar Card">Aadhaar Card</option>
                        <option value="Passport">Passport</option>
                      </select>
                      <input
                        type="text"
                        className="d-none"
                        id="txttrustd2AadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btntrustd2Aadhaar"
                        onClick={() =>
                          this.toggleModal("trustd2uploadModalAadhaar")
                        }
                        disabled={
                          !this.state.trustd2ddlAddress ||
                          this.state.trustd2ddlAddress === "-1"
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 1 : PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txttrustd1PanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btntrustd1Pan"
                        onClick={() =>
                          this.toggleModal("trustd1uploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Director 2 : PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txttrustd2PanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btntrustd2Pan"
                        onClick={() =>
                          this.toggleModal("trustd2uploadModalPan")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>

                  {/* <div className="my-5 py-5"></div> */}

                  <div className="div-btn-nxt dv-ind-btn">
                    <div className="btn-holder mt-5 text-center">
                      <button
                        className="btn btn-next btn-gradient"
                        onClick={this.checkNthank}
                      >
                        Next
                      </button>
                    </div>
                  </div>

                  {/* <div className="div-btn-nxt dv-prop-btn">
                                        <div className="btn-holder mt-5 text-center">
                                            <a href="/businessprop" className="btn btn-next btn-gradient">
                                                Next
                                            </a>
                                        </div>
                                    </div>

                                    <div className="div-btn-nxt dv-part-btn">
                                        <div className="btn-holder mt-5 text-center">
                                            <a href="/businesspart" className="btn btn-next btn-gradient">
                                                Next
                                            </a>
                                        </div>
                                    </div>

                                    <div className="div-btn-nxt dv-pub-btn">
                                        <div className="btn-holder mt-5 text-center">
                                            <a href="/businesspub" className="btn btn-next btn-gradient">
                                                Next
                                            </a>
                                        </div>
                                    </div>

                                    <div className="div-btn-nxt dv-soc-btn">
                                        <div className="btn-holder mt-5 text-center">
                                            <a href="/businesssoc" className="btn btn-next btn-gradient">
                                                Next
                                            </a>
                                        </div>
                                    </div> */}

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal
          className="modal-dialog-centered modal-lg uploadModal"
          isOpen={this.state.uploadModal}
          toggle={() => this.toggleModal("uploadModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("uploadModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <div className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Image</h5>
              </div>
              <div className="dv-upload-img">
                <p>Upload Image</p>
              </div>
              <div className="btn-holder mt-3 text-center">
                <button
                  type="submit"
                  className={
                    this.state.isLoaded
                      ? `btn btn-gradient bt-wd disable-btn`
                      : `btn btn-gradient bt-wd`
                  }
                  disabled={this.state.isLoaded}
                >
                  Submit{" "}
                  {this.state.isLoaded ? (
                    <Spinner size="sm" color="light" className="btn-loader" />
                  ) : null}
                </button>
              </div>
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </div>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.individualuploadModalPan}
          toggle={() => this.toggleModal("individualuploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("individualuploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.individualsubmitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.individualfilePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="individualfileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.individualpreviewPan}
                />
                <img
                  className="img-preview"
                  id="imgIndividualfileItemPan"
                  src={
                    this.state.individualfilePan
                      ? this.state.individualfilePan
                      : uploadImg
                  }
                />

                <label id="lblindividualfileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panCardNameInd">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardNameInd"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panCardFNameInd">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardFNameInd"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panCardNuInd">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardNuInd"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panCardDOBInd">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardDOBInd"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "individualuploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg individualuploadModalAadhaar"
          isOpen={this.state.individualuploadModalAadhaar}
          toggle={() => this.toggleModal("individualuploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("individualuploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>

            <form onSubmit={this.individualsubmitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="individualaddressProof">
                  Please upload your {this.state.individualddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.individualfileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="individualfileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.individualpreviewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.individualfileFront
                          ? this.state.individualfileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblindividualfileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.individualfileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="individualfileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.individualpreviewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.individualfileBack
                          ? this.state.individualfileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lblindividualfileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="nameIndividual">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameIndividual"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idIndividual">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idIndividual"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressIndividual">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressIndividual"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.individualddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.individualddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "individualuploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}

              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.proprietoruploadModalPan}
          toggle={() => this.toggleModal("proprietoruploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("proprietoruploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.proprietorsubmitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.proprietorfilePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="proprietorfileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.proprietorpreviewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.proprietorfilePan
                      ? this.state.proprietorfilePan
                      : uploadImg
                  }
                />
                <label id="lblproprietorfileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panCardNamePro">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardNamePro"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panCardFNamePro">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardFNamePro"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panCardNuPro">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardNuPro"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panCardDOBPro">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panCardDOBPro"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}

              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "proprietoruploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg proprietoruploadModalAadhaar"
          isOpen={this.state.proprietoruploadModalAadhaar}
          toggle={() => this.toggleModal("proprietoruploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("proprietoruploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.proprietorsubmitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="proprietoraddressProof">
                  Please upload your {this.state.proprietorddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.proprietorfileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="proprietorfileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.proprietorpreviewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.proprietorfileFront
                          ? this.state.proprietorfileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblproprietorfileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.proprietorfileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="proprietorfileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.proprietorpreviewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.proprietorfileBack
                          ? this.state.proprietorfileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lblproprietorfileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="aadharNamePropriet">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="namePropriet"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="aadharIdPropriet">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idPropriet"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="aadharAddress">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressPropriet"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.proprietorddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.proprietorddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "proprietoruploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.partnerd1uploadModalPan}
          toggle={() => this.toggleModal("partnerd1uploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerd1uploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerd1submitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.partnerd1filePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="partnerd1fileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.partnerd1previewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.partnerd1filePan
                      ? this.state.partnerd1filePan
                      : uploadImg
                  }
                />
                <label id="lblpartnerd1fileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNamePartnerd1">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNamePartnerd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panFNamePartnerd1">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panFNamePartnerd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNuPartnerd1">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNuPartnerd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panDOBPartnerd1">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panDOBPartnerd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "partnerd1uploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg partnerd1uploadModalAadhaar"
          isOpen={this.state.partnerd1uploadModalAadhaar}
          toggle={() => this.toggleModal("partnerd1uploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerd1uploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerd1submitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="partnerd1addressProof">
                  Please upload your {this.state.partnerd1ddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.partnerd1fileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="partnerd1fileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.partnerd1previewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.partnerd1fileFront
                          ? this.state.partnerd1fileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpartnerd1fileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.partnerd1fileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="partnerd1fileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.partnerd1previewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.partnerd1fileBack
                          ? this.state.partnerd1fileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpartnerd1fileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="namePartnerd1">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="namePartnerd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idPartnerd1">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idPartnerd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressPartnerd1">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressPartnerd1"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.partnerd1ddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.partnerd1ddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "partnerd1uploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.partnerd2uploadModalPan}
          toggle={() => this.toggleModal("partnerd2uploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerd2uploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerd2submitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.partnerd2filePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="partnerd2fileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.partnerd2previewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.partnerd2filePan
                      ? this.state.partnerd2filePan
                      : uploadImg
                  }
                />
                <label id="lblpartnerd2fileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNamePartnerd2">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNamePartnerd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panFNamePartnerd2">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panFNamePartnerd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNuPartnerd2">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNuPartnerd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panDOBPartnerd2">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panDOBPartnerd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "partnerd2uploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg partnerd2uploadModalAadhaar"
          isOpen={this.state.partnerd2uploadModalAadhaar}
          toggle={() => this.toggleModal("partnerd2uploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerd2uploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerd2submitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="partnerd2addressProof">
                  Please upload your {this.state.partnerd2ddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.partnerd2fileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="partnerd2fileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.partnerd2previewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.partnerd2fileFront
                          ? this.state.partnerd2fileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpartnerd2fileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.partnerd2fileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="partnerd2fileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.partnerd2previewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.partnerd2fileBack
                          ? this.state.partnerd2fileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpartnerd2fileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              {/* {this.state.partnerd2ddlAddress === 'Aadhaar Card' && */}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="namePartnerd2">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="namePartnerd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idPartnerd2">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idPartnerd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressPartnerd2">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressPartnerd2"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.partnerd2ddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* } */}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.partnerd2ddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "partnerd2uploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.publicd1uploadModalPan}
          toggle={() => this.toggleModal("publicd1uploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicd1uploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicd1submitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.publicd1filePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="publicd1fileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.publicd1previewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.publicd1filePan
                      ? this.state.publicd1filePan
                      : uploadImg
                  }
                />
                <label id="lblpublicd1fileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNamePublicd1">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNamePublicd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panFNamePublicd1">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panFNamePublicd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNuPublicd1">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNuPublicd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panDOBPublicd1">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panDOBPublicd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "publicd1uploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg publicd1uploadModalAadhaar"
          isOpen={this.state.publicd1uploadModalAadhaar}
          toggle={() => this.toggleModal("publicd1uploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicd1uploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicd1submitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="publicd1addressProof">
                  Please upload your {this.state.publicd1ddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.publicd1fileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicd1fileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.publicd1previewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicd1fileFront
                          ? this.state.publicd1fileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpublicd1fileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.publicd1fileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicd1fileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.publicd1previewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicd1fileBack
                          ? this.state.publicd1fileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpublicd1fileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              {/* {this.state.publicd1ddlAddress === 'Aadhaar Card' && */}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="namePublicd1">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="namePublicd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idPublicd1"> ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idPublicd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressPublicd1">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressPublicd1"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.publicd1ddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* } */}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.publicd1ddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "publicd1uploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.publicd2uploadModalPan}
          toggle={() => this.toggleModal("publicd2uploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicd2uploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicd2submitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.publicd2filePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="publicd2fileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.publicd2previewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.publicd2filePan
                      ? this.state.publicd2filePan
                      : uploadImg
                  }
                />
                <label id="lblpublicd2fileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNamePublicd2">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNamePublicd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panFNamePublicd2">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panFNamePublicd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNuPublicd2">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNuPublicd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panDOBPublicd2">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panDOBPublicd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "publicd2uploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg publicd2uploadModalAadhaar"
          isOpen={this.state.publicd2uploadModalAadhaar}
          toggle={() => this.toggleModal("publicd2uploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicd2uploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicd2submitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="publicd2addressProof">
                  Please upload your {this.state.publicd2ddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.publicd2fileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicd2fileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.publicd2previewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicd2fileFront
                          ? this.state.publicd2fileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpublicd2fileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.publicd2fileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicd2fileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.publicd2previewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicd2fileBack
                          ? this.state.publicd2fileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpublicd2fileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              {/* {this.state.publicd2ddlAddress === 'Aadhaar Card' && */}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="namePublicd2">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="namePublicd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idPublicd2">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idPublicd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressPublicd2">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressPublicd2"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.publicd2ddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* } */}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.publicd2ddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "publicd2uploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.trustd1uploadModalPan}
          toggle={() => this.toggleModal("trustd1uploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("trustd1uploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.trustd1submitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.trustd1filePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="trustd1fileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.trustd1previewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.trustd1filePan
                      ? this.state.trustd1filePan
                      : uploadImg
                  }
                />
                <label id="lbltrustd1fileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNameTrustd1">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNameTrustd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panFNameTrustd1">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panFNameTrustd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNuTrustd1">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNuTrustd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panDOBTrustd1">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panDOBTrustd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "trustd1uploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg trustd1uploadModalAadhaar"
          isOpen={this.state.trustd1uploadModalAadhaar}
          toggle={() => this.toggleModal("trustd1uploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("trustd1uploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.trustd1submitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="trustd1addressProof">
                  Please upload your {this.state.trustd1ddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.trustd1fileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="trustd1fileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.trustd1previewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.trustd1fileFront
                          ? this.state.trustd1fileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lbltrustd1fileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.trustd1fileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="trustd1fileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.trustd1previewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.trustd1fileBack
                          ? this.state.trustd1fileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lbltrustd1fileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              {/* {this.state.trustd1ddlAddress === 'Aadhaar Card' && */}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="nameTrustd1">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameTrustd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idTrustd1">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idTrustd1"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressTrustd1">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressTrustd1"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.trustd1ddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* } */}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.trustd1ddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "trustd1uploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.trustd2uploadModalPan}
          toggle={() => this.toggleModal("trustd2uploadModalPan")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("trustd2uploadModalPan")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.trustd2submitPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              <div className="dv-upload-img">
                {this.state.trustd2filePan && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="trustd2fileItemPan"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.trustd2previewPan}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.trustd2filePan
                      ? this.state.trustd2filePan
                      : uploadImg
                  }
                />
                <label id="lbltrustd2fileItemPan" className="d-none"></label>
              </div>
              {this.state.fileSizeError3 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg3}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNameTrustd2">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNameTrustd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panFNameTrustd2">Father Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panFNameTrustd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="panNuTrustd2">PAN No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panNuTrustd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="panDOBTrustd2">Date of Birth</label>
                      <input
                        type="text"
                        className="form-control"
                        id="panDOBTrustd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.imageUploadedError3 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "trustd2uploadModalPan")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg trustd2uploadModalAadhaar"
          isOpen={this.state.trustd2uploadModalAadhaar}
          toggle={() => this.toggleModal("trustd2uploadModalAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("trustd2uploadModalAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.trustd2submitAddress} className="dv-upload">
              <div className="dv-upload-header">
                <h5 id="trustd2addressProof">
                  Please upload your {this.state.trustd2ddlAddress} copy
                </h5>
                <p>Please upload front &amp; back side</p>
              </div>
              <div className="row ad-upld">
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.trustd2fileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="trustd2fileItemFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.trustd2previewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.trustd2fileFront
                          ? this.state.trustd2fileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lbltrustd2fileItemFront"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Front Side</p>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg1}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="dv-upload-img-small">
                    {this.state.trustd2fileBack && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="trustd2fileItemBack"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.trustd2previewBack}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.trustd2fileBack
                          ? this.state.trustd2fileBack
                          : uploadImg
                      }
                    />
                    <label
                      id="lbltrustd2fileItemBack"
                      className="d-none"
                    ></label>
                  </div>
                  <p className="text-center mod-txt">Back Side</p>
                  {this.state.fileSizeError2 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg2}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                </div>
              </div>
              {/* {this.state.trustd2ddlAddress === 'Aadhaar Card' && */}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              <div className="filledDet">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="nameTrustd2">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameTrustd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="idTrustd2">ID No.</label>
                      <input
                        type="text"
                        className="form-control"
                        id="idTrustd2"
                        placeholder=""
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="addressTrustd2">Address</label>
                      <textarea
                        className="form-control addtxtarea"
                        name=""
                        id="addressTrustd2"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  {this.state.imageUploadedError1 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Front part of image
                    </p>
                  )}
                  {this.state.imageUploadedError2 && (
                    <p className="err" style={{ textAlign: "center" }}>
                      Please upload Back part of image
                    </p>
                  )}
                  {this.state.trustd2ddlAddress === "Aadhaar Card" && (
                    <div className="col-md-12">
                      <div className="form-group form-check m-2 px-0">
                        <input
                          type="checkbox"
                          className="form-check-input cont-chk-inpt ml-0"
                          id="chkAgreeAadhar"
                          onChange={(e) =>
                            this.setState({ agree: !this.state.agree })
                          }
                          checked={this.state.agree}
                        />
                        <label
                          className="form-check-label cont-chk ml-4 pl-2"
                          htmlFor="chkAgreeAadhar"
                        >
                          I have understood the purpose and importance of
                          providing the aadhar details, therefore I am
                          Voluntarily consent to provide the required details.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* } */}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={
                      this.state.isLoaded ||
                      (this.state.trustd2ddlAddress === "Aadhaar Card" &&
                        !this.state.agree)
                    }
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "trustd2uploadModalAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>
        <Modal
          className="modal-dialog-centered modal-lg loginModal"
          isOpen={this.state.loginModal}
          toggle={() => this.toggleModal("loginModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            {/* <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("loginModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button> */}
            <h5 style={{ textAlign: "center" }}>
              Session Expired, Please Login to continue
            </h5>
            <div className="btn-holder mt-3 text-center">
              <button
                onClick={this.handleLogin}
                className="btn btn-gradient bt-wd"
              >
                Login
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default PersonalDoc;
